/**
 * Central theme colour definitions for consistent UI across pages.
 * Use these instead of hardcoding Tailwind colour classes (amber, emerald, purple, blue, etc.).
 *
 * Usage:
 *   import { themeColors } from '../config/themeColors';
 *   themeColors.amber.cardHover
 *   themeColors.purple.buttonHover
 */

/**
 * Tailwind needs to see full class names at build time, so we use string literals
 * rather than dynamic classes.
 */
export const themeColors = {
  amber: {
    cardHover: 'ring-1 ring-gray-200 hover:ring-amber-300 hover:shadow-md transition-all duration-200',
    buttonHover: 'hover:border-amber-400 hover:text-amber-600 transition',
    link: 'text-amber-600 hover:text-amber-800 font-medium underline transition',
    border: 'border-amber-500',
    borderLight: 'border-amber-200',
    borderThin: 'border-amber-100',
    bg: 'bg-amber-50',
    bgMuted: 'bg-amber-50/50',
  },
  emerald: {
    cardHover: 'ring-1 ring-gray-200 hover:ring-emerald-300 hover:shadow-md transition-all duration-200',
    buttonHover: 'hover:border-emerald-400 hover:text-emerald-600 transition',
    link: 'text-emerald-600 hover:text-emerald-800 font-medium underline transition',
    border: 'border-emerald-500',
    borderLight: 'border-emerald-200',
    borderThin: 'border-emerald-100',
    bg: 'bg-emerald-50',
    bgMuted: 'bg-emerald-50/50',
  },
  purple: {
    cardHover: 'ring-1 ring-gray-200 hover:ring-purple-300 hover:shadow-md transition-all duration-200',
    buttonHover: 'hover:border-purple-400 hover:text-purple-600 transition',
    link: 'text-purple-600 hover:text-purple-800 font-medium underline transition',
    border: 'border-purple-500',
    borderLight: 'border-purple-200',
    borderThin: 'border-purple-100',
    bg: 'bg-purple-50',
    bgMuted: 'bg-purple-50/50',
  },
  blue: {
    cardHover: 'ring-1 ring-gray-200 hover:ring-blue-300 hover:shadow-md transition-all duration-200',
    buttonHover: 'hover:border-blue-400 hover:text-blue-600 transition',
    link: 'text-blue-600 hover:text-blue-800 font-medium underline transition',
    border: 'border-blue-500',
    borderLight: 'border-blue-200',
    borderThin: 'border-blue-100',
    bg: 'bg-blue-50',
    bgMuted: 'bg-blue-50/50',
  },
};

/** Semantic aliases for common contexts (optional; pages can use themeColors.amber etc. directly) */
export const themeSemantic = {
  /** CORTEX essay competition primary (D1, general CORTEX CTAs) */
  cortex: themeColors.amber,
  /** CORTEX essay competition D2 */
  cortexD2: themeColors.emerald,
  /** JELTR / Instagram buttons and links */
  jeltr: themeColors.purple,
};

/** CORTEX / conference pages — pill outline control (same as “Submit an Abstract” on Conference 2026). */
export const cortexOutlineButtonClass =
  'inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition';
